import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { logsApi, type UserActivityLog } from "@/api";

export default function UserLogs() {
  const { data: logs = [], isLoading } = useQuery<UserActivityLog[]>({
    queryKey: ["user-activity-logs"],
    queryFn: async () => {
      const res = await logsApi.userActivity({ limit: 200 });
      return res.data || [];
    },
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">使用者日誌</h1>
        <p className="text-muted-foreground">使用者活動追蹤紀錄</p>
      </div>

      <Card>
        <CardHeader><CardTitle>活動紀錄</CardTitle></CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="flex items-center justify-center py-8"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
          ) : logs.length === 0 ? (
            <div className="text-center text-muted-foreground py-8">尚無活動紀錄</div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>時間</TableHead>
                  <TableHead>使用者</TableHead>
                  <TableHead>操作</TableHead>
                  <TableHead>詳情</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {logs.map(log => (
                  <TableRow key={log.id}>
                    <TableCell className="text-sm text-muted-foreground whitespace-nowrap">{new Date(log.created_at).toLocaleString("zh-TW")}</TableCell>
                    <TableCell className="text-sm">{log.user_id?.substring(0, 8) || "—"}</TableCell>
                    <TableCell className="text-sm">{log.action}</TableCell>
                    <TableCell className="text-sm max-w-[300px] truncate">{log.details || "—"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
